import React, { Component } from 'react';
import {Redirect, Route, Switch, withRouter} from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { MobileView } from 'react-device-detect';
import globals from '../../globals';
import animations from './animations';
import Navigation from '../Navigation';
import Home from '../../pages/Home';
import InternetOverview from '../../internet/InternetOverview';
import NotFound from '../../pages/NotFound';
import InternetFibre from '../../internet/InternetFibre';
import InternetWireless from '../../internet/InternetWireless';
import Voip from '../../voip/Voip';
import SmallBusinessVoip from '../../voip/SmallBusinessVoip';
import ManagedServices from '../../pages/ManagedServices';
import NetworkSolutions from '../../networkSolutions/NetworkSolutions';
import Partners from '../../pages/Partners';
import SlideFormContainer from '../SlideFormContainer/SlideFormContainer';
import Footer from '../Footer';
import Nbn from '../../nbn/Nbn/Nbn';
import SmallBusiness from '../../pages/SmallBusiness';
import BusinessVoip from '../../voip/BusinessVoip';
import Login from '../../pages/Login';
import Contact from '../../pages/Contact';
import BackToTop from '../BackToTop/BackToTop';
import ErrorBoundary from "../ErrorBoundary";
import UnifiedCommunications from "../../voip/UnifiedCommunications/UnifiedCommunications";
import SentryTest from "../../pages/SentryTest";
import CloudConnectivity from "../../networkSolutions/CloudConnectivity";
import IpTransit from "../../networkSolutions/IpTransit";
import InternationalNetworks from "../../networkSolutions/InternationalNetworks";
import InboundServices from "../../voip/InboundServices";
import BulkSms from "../../voip/BulkSms";
import InternetEnterpriseNbn from "../../internet/InternetEnterpriseNbn";
import AwsPartners from "../../pages/AwsPartner";
import WirelessBackup from "../../internet/WirelessBackup";
import WorkFromHome from "../../voip/WorkFromHome";
import TelstraCoverage from "../../pages/TelstraCoverage";
import OptusCoverage from "../../pages/OptusCoverage";
import CaseStudiesOverview from '../../caseStudies/CaseStudiesOverview';
import CaseStudiesBusiness from '../../caseStudies/CaseStudiesBusiness';
import MobileFleet from '../../pages/MobileFleet';
import FlipToFibre from '../../flipToFibre/FlipToFibre';
import MySpeedBoost from "../../pages/MySpeedBoost";
import BanterPrivacyPolicy from "../../pages/BanterPrivacyPolicy";
import { jwtDecode } from 'jwt-decode';
import { agentLogout, isTokenValid } from '../../utils/agentUtil';

class App extends Component {
    constructor(listen) {
        super(listen);

        this.doNotAnimate = [
            'small-business/nbn/'
        ];
        this.screenSm = 991;
        this.state = {
            isMobile: (window.innerWidth <= this.screenSm)
        };

        // NB: If changing these also change them in the react.blade.php view file
        this.seoTitle = 'Exetel for Business | Data, Voice and Communications Solutions';
        this.seoDescription = "Exetel's simple data plans, voice and communication solutions have the power to deliver real value to asmall and medium sized business";
    }

    componentDidMount() {
        this.setBodyClass();
        animations.animateIn(this.container);
        this.refreshOnScreenChange();
        this.handleToken();
        this.handleUtmSource()
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            let doNotAnimate = false;

            // Do not animate tab changes only main nav changes
            this.doNotAnimate.map(url => {
                if (this.props.location.pathname.includes(url)) {
                    doNotAnimate = true;
                }
            });

            this.setBodyClass();
            if (!doNotAnimate) {
                this.Navigation.resetNavigation();
                window.scrollTo(0, 0);
            }
        }

        this.handleToken();
        this.handleUtmSource()
    }

    handleUtmSource() {
        const searchParams = new URLSearchParams(location.search);
        const utmSource = searchParams.get('utm_source');
    
        if (utmSource) {
            sessionStorage.setItem('utm_source', utmSource);
        }
    }

    handleToken () {
        const searchParams = new URLSearchParams(
            location.search
        );
        const token = searchParams.get("agent-token");
        const conversationId = searchParams.get("conversation_id");
        if (conversationId) {
            sessionStorage.setItem('conversation_id', conversationId);
        }
        if (token) {
            try {
                const decodedToken = jwtDecode(token)
                if (isTokenValid(decodedToken.exp)) {
                    localStorage.setItem('orderFormToken', token);
                    if (decodedToken.name && decodedToken.agent_code) {
                        const firstName = decodedToken.name.split(' ')[0]
                        localStorage.setItem('agentUsername', firstName);
                        localStorage.setItem('agentCode', decodedToken.agent_code);
                        localStorage.setItem('expiry', decodedToken.exp);
                        localStorage.setItem('isAgent', 'true');
                    }
                } else {
                    agentLogout()
                }
            } catch (error) {
                agentLogout()
            }
        } else if (localStorage.getItem('isAgent') === null) {
            agentLogout()
        } else if (localStorage.getItem('isAgent') === 'true') {
            if (!isTokenValid(parseInt(localStorage.getItem('expiry'), 10))) {
                agentLogout();
            }
        }
    }

    setBodyClass() {
        let segments = this.props.location.pathname.split('/'),
            className = globals.convertToSlug(this.props.location.pathname);

        /* Add support for tabbed URLs (ie. small-business/nbn/register */
        if (segments.length >= 4) {
            className = globals.convertToSlug('/' + segments[1] + '/' + segments[2]);
        }

        document.body.className = '';
        document.body.classList.add((className === '' ? 'home' : className));
    }

    refreshOnScreenChange() {
        /* Refresh the page if the screen size is changed from mobile to desktop or vice versa */
        let resizeTimer;
        window.onresize = () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                if (this.state.isMobile !== (window.innerWidth <= this.screenSm)) {
                    location.reload(true);
                }
            }, 500);
        };
    }

    render() {
        const DoRedirect = () => {
            return <Redirect to="/" />;
        };

        return (
            <div className="container-fluid" style={{opacity: 0}} ref={el => this.container = el}>
                <Helmet title={this.seoTitle} meta={[{name: 'description', content: this.seoDescription}]} />
                <SlideFormContainer ref={el => window.slideFormContainer = el} />
                <Navigation ref={(el) => this.Navigation = el} />
                <ErrorBoundary>
                    <Switch>
                        <Route exact path="/" component={Home} />
                        <Route exact path="/internet" component={InternetOverview} />
                        <Route exact path="/internet/business-fibre" component={InternetFibre} />
						<Route exact path="/internet/wireless-backup" component={WirelessBackup} />
                        <Route exact path="/internet/business-wireless" component={InternetWireless} />
                        <Route exact path="/internet/nbn-enterprise-ethernet" component={InternetEnterpriseNbn} />
                        <Route exact path="/internet/business-ethernet" render={DoRedirect} />
                        <Route exact path="/internet/business-grade-tc2-nbn" render={DoRedirect} />
                        <Route exact path="/voip" component={Voip} />
                        <Route exact path="/voip/banter-work-from-home" component={WorkFromHome} />
                        <Route exact path="/voip/unified-communications" component={UnifiedCommunications} />
                        <Route exact path="/voip/business" component={BusinessVoip} />
                        <Route exact path="/voip/small-business" component={DoRedirect} />
                        <Route exact path="/voip/inbound-services" component={InboundServices} />
                        <Route exact path="/voip/bulk-sms" component={BulkSms} />
                        <Route exact path="/network-solutions" component={NetworkSolutions} />
                        <Route exact path="/network-solutions/managed-services" component={ManagedServices} />
                        <Route exact path="/network-solutions/cloud-connectivity" component={CloudConnectivity} />
                        <Route exact path="/network-solutions/ip-transit" component={IpTransit} />
                        <Route exact path="/network-solutions/international-networks" component={InternationalNetworks} />
                        <Route exact path="/small-business" component={SmallBusiness} />
                        <Route exact path="/small-business/nbn" component={Nbn} />
                        <Route exact path="/small-business/nbn/register" render={() => <Redirect to="/small-business/nbn" status={301} />} />
                        <Route exact path="/small-business/nbn/about-nbn-speed" render={() => <Redirect to="/small-business/nbn" status={301} />} />
                        <Route exact path="/small-business/nbn/features" render={() =><Redirect to="/small-business/nbn" status={301} />} />
                        <Route exact path="/small-business/nbn/plans" render={() =><Redirect to="/small-business/nbn" status={301} />} />
                        <Route exact path="/partners" component={Partners} />
                        <Route exact path="/login" component={Login} />
                        <Route exact path="/contact" component={Contact} />
                        <Route exact path="/aws-partner" component={AwsPartners} />
                        <Route exact path="/sentry-test-error" component={SentryTest} />
                        <Route exact path="/coverage/telstra" component={TelstraCoverage} />
                        <Route exact path="/coverage/optus" component={OptusCoverage} />
                        <Route exact path="/case-studies" component={CaseStudiesOverview} />
                        <Route exact path="/case-studies/:type" component={CaseStudiesBusiness} />
                        <Route exact path="/mobile-fleet" component={MobileFleet} />
                        <Route exact path="/flip-to-fibre" component={FlipToFibre} />
                        <Route exact path="/speed-boost" component={MySpeedBoost} />
                        <Route exact path="/banter-privacy-policy" component={BanterPrivacyPolicy} />
                        <Route component={NotFound} />
                    </Switch>
                </ErrorBoundary>
                <MobileView>
                    <BackToTop />
                </MobileView>
                <Footer />
            </div>
        );
    }
}

export default withRouter(App);


// WEBPACK FOOTER //
// ./resources/assets/js/layout/App/App.js